module.exports = " <div> <div class=or-cookie__banner v-if=tstringsReady> <div class=or-cookie__text>{{tstrings.KOKUAPP.COOKIE_MSG}} <a :href=cookieLink>{{tstrings.KOKUAPP.COOKIE_PAGE_LINK_TEXT}}</a></div> <div class=or-cookie__buttons> <button class=or-cookie__button v-on:click=approve>{{tstrings.KOKUAPP.AGREE}}</button> <button class=or-cookie__button v-on:click=toggleSettings>{{tstrings.KOKUAPP.COOKIE_SETTINGS}}</button> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/kokuapp/cookie-banner.vue
// module id = 230
// module chunks = 13 14